import { ChevronRight } from "lucide-react";
import Link from "next/link";

export interface SectionHeaderProps {
  readonly actionLabel: string;
  readonly actionVariant?: "outlined" | "text";
  readonly href: string;
  readonly title: string;
}

export function SectionHeader({
  actionLabel,
  actionVariant = "text",
  href,
  title,
}: Readonly<SectionHeaderProps>) {
  return (
    <div className="mb-3 flex items-center justify-between gap-4">
      <h2 className="min-w-0 text-lg font-extrabold leading-6 text-primary sm:text-[22px] sm:leading-8">
        {title}
      </h2>
      <Link
        className={`inline-flex min-h-11 shrink-0 items-center gap-1 rounded-lg text-[14px] font-bold text-primary outline-none transition-colors focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 sm:text-[15px] ${
          actionVariant === "outlined"
            ? "border border-primary/30 bg-surface px-3 hover:border-primary hover:bg-primary/5"
            : "px-1 hover:text-primary-container"
        }`}
        href={href}
        prefetch={false}
      >
        {actionLabel}
        <ChevronRight aria-hidden="true" size={17} strokeWidth={2} />
      </Link>
    </div>
  );
}
